import serverVars from 'server-vars';
import { getBuyerId } from 'dibs-cookie-jar';

import { createReduxStore } from '../reducers/reducerUtils.js';
import { clientRelayEnvironment } from '../clientRelayEnvironment.ts';
import { setRelayVariables } from '../actions/sharedRelayVariableActions.js';
import { setIntlVariables } from '../actions/sharedIntlVariablesActions.js';
import { renderEntryComponent } from '../utils/renderEntryComponent.jsx';
import { sharedLoginCheckSetUp } from '../authentication/sharedLoginCheck.ts';
import { addLoginHandlers } from 'dibs-buyer-layout/src/utils/loginHandlers.ts';
import { updateToken } from '../actions/authActions.js';

export function createEntry(payload = {}) {
    const {
        Container,
        query,
        store,
        dangerouslyConnectToStore,
        queue = {},
        actions = {},
    } = payload;

    const relayVariables = serverVars.get('relay.variables');
    const intlVariables = serverVars.get('intlVariables');
    const { environment, socketListeners } =
        payload?.environment && payload?.socketListeners
            ? payload
            : clientRelayEnvironment(serverVars.get('dbl.relayData'));
    const reduxStore = store || createReduxStore();

    sharedLoginCheckSetUp({ store: reduxStore, environment });

    reduxStore.dispatch(setRelayVariables(relayVariables));
    reduxStore.dispatch(setIntlVariables(intlVariables));

    if (Container) {
        renderEntryComponent({
            Component: Container,
            store: reduxStore,
            query,
            variables: relayVariables,
            environment,
            containerId: 'js-root',
            dangerouslyConnectToStore,
            runNotificationQueue: queue.runNotificationQueue || (() => {}),
            reinitTracking: actions.reinitTracking,
            socketListeners,
        });
    }

    addLoginHandlers(() => {
        const userId = getBuyerId(document.cookie);
        if (userId) {
            reduxStore.dispatch(updateToken({ userId }));
        }
    });
}
